/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

/**
 * Status Pipe on column table
 */
import {StatusCellValueModel} from './status-cell-value.model';
import {PartnerCellValueModel} from './partner-cell-value.model';
import {OldPartNumberCellValueModel} from './old-part-number-cell-value.model';
import {UserBaseContract} from '../../../api/ms-partnumberchanges/contracts/user-base.contract';
import {TechnicianGroupBaseModel} from '../../models/technician-group-model/technician-group-base.model';
import {SupplyingPackingPlantBaseModel} from '../../models/supplying-packing-plant/supplying-packing-plant-base.model';

export function statusPipe(cellValue: StatusCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.name != null) {
            displayValue = `${cellValue.name}`;
        }
    }
    return displayValue;
}

export function partnerPipe(cellValue: PartnerCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.code != null && cellValue.name != null) {
            displayValue = `${cellValue.code} ${cellValue.name}`;
        }
    }
    return displayValue;
}

export function partNumberPipe(cellValue: OldPartNumberCellValueModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.number != null && cellValue.description != null) {
            displayValue = `${cellValue.number} - ${cellValue.description}`;
        }
    }
    return displayValue;
}

export function userPipe(cellValue: UserBaseContract): string {
    let displayValue = '-';
    if (cellValue != null) {

        if (cellValue.username != null) {
            displayValue = cellValue.username;

            if (cellValue.email != null) {
                displayValue = `${cellValue.email} (${cellValue.username})`;
            }
        }
    }
    return displayValue;
}

export function techniciansGroupPipe(cellValue: TechnicianGroupBaseModel): string {
    let displayValue = '-';
    if (cellValue != null) {
        if (cellValue.name != null) {
            displayValue = `${cellValue.name}`;
        }
    }
    return displayValue;
}

export function supplyingPackingPlantPipe(cellValue: SupplyingPackingPlantBaseModel): string {
    let displayValue = '-';
    if (cellValue?.name != null && cellValue?.code != null) {
        displayValue = `${cellValue.code} - ${cellValue.name}`;
    }
    return displayValue;
}

export function doneUndonePipe(cellValue: boolean): string {
    let displayValue = '-';
    if (cellValue != null) {
        displayValue = cellValue ? 'Done' : 'Undone';
    }
    return displayValue;
}

